<abp-modal [visible]="visible" (disappear)="closeModal()" [options]="{ size: 'lg' }">
  <ng-template #abpHeader>
    <div style="height: 60px">
      <div class="w-100 d-flex align-items-center ai-usage-disclaimer-header">
        <h3>{{ '::BrandingSettings:AIUsageDisclaimer' | abpLocalization }}</h3>
      </div>
    </div>
  </ng-template>

  <ng-template #abpBody>
    <div class="w-100" style="margin-top: -24px">
      @if (isLoading) {
        <div class="text-center py-4">
          <i class="fa fa-spinner fa-spin fa-2x"></i>
        </div>
      } @else if (sanitizedHtml) {
        <!-- Custom disclaimer from branding settings (Markdown support with XSS protection) -->
        <div class="custom-disclaimer-content">
          <markdown [data]="sanitizedHtml"></markdown>
        </div>
      } @else {
        <!-- Default multi-language disclaimer -->
        @for (content of disclaimer.content; track $index) {
          <h4>{{ content.title }}</h4>

          <p>
            @for (description of content.descriptions; track $index) {
              <div [innerHTML]="description"></div>
            }
          </p>
        }
      }
    </div>
  </ng-template>

  <ng-template #abpFooter>
    <div [formGroup]="form" class="d-flex justify-content-between align-items-center w-100">
      <div class="ms-2">
        @if (showSwitch) {
          <nz-switch nzSize="small" formControlName="doNotShowAgain"></nz-switch>
          <label class="ms-3 mb-2">
            {{ '::DoNotShowThisMessageAgain' | abpLocalization }}
          </label>
        }
      </div>

      <button type="button" class="btn btn-primary" (click)="closeModal()">
        {{ 'AbpUi::Close' | abpLocalization }}
      </button>
    </div>
  </ng-template>
</abp-modal>
